import { Box, Center, Divider, Flex, FormLabel, Grid, GridItem, Input, Spinner, Text, VStack } from '@chakra-ui/react'
import { useProperty } from 'api/property'

const PropertyAndClientTab = ({ propertyId }: { propertyId?: string }) => {
  const { propertyData, isLoading } = useProperty(propertyId, true)
  return (
    <Box mb={5}>
      {isLoading ? (
        <Center height={350}>
          <Spinner size="lg" />
        </Center>
      ) : (
        <Box pr="10px" data-testid="order-intake-container" marginBottom="100px">
          <VStack w={'90%'} spacing={4} align="stretch">
            <Box>
              <Flex alignItems={'center'}>
                <Text fontWeight={'500'} fontSize={'md'} display={'inline-block'} flexGrow={1} w={'25%'}>
                  Address&nbsp;Information
                </Text>
                <Divider borderWidth={'1px'} borderColor={'#CBD5E0'} />
              </Flex>
              <Box pt={'3'}>
                <Grid templateColumns="repeat(3, 280px)" gap="25px" pb={3}>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Street
                    </FormLabel>
                    <Input
                      isDisabled={true}
                      value={propertyData?.streetAddress ? propertyData?.streetAddress : '---'}
                    />
                  </GridItem>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Unit
                    </FormLabel>
                    <Input isDisabled={true} value={propertyData?.unitNo ? propertyData?.unitNo : '---'} />
                  </GridItem>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      City
                    </FormLabel>
                    <Input value={propertyData?.city ? propertyData?.city : '---'} isDisabled={true} />
                  </GridItem>
                </Grid>
                <Grid templateColumns="repeat(3, 280px)" gap="25px">
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      State
                    </FormLabel>
                    <Input isDisabled={true} value={propertyData?.state ? propertyData?.state : '---'} />
                  </GridItem>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Zip Code
                    </FormLabel>
                    <Input isDisabled={true} value={propertyData?.zipCode ? propertyData?.zipCode : '---'} />
                  </GridItem>
                </Grid>
              </Box>
            </Box>
            <Box pt={'4'}>
              <Flex alignItems={'center'}>
                <Text fontWeight={'500'} fontSize={'md'} display={'inline-block'} flexGrow={1} w={'25%'}>
                  Resident&nbsp;Information
                </Text>
                <Divider borderWidth={'1px'} borderColor={'#CBD5E0'} />
              </Flex>
              <Box pt={'3'}>
                <Grid templateColumns="repeat(3, 280px)" gap="25px" pb={2}>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Name
                    </FormLabel>
                    <Input
                      isDisabled={true}
                      value={
                        Array.isArray(propertyData?.residents) && propertyData?.residents[0]
                          ? propertyData?.residents[0]?.firstName + ' ' + propertyData?.residents[0]?.lastName
                          : '---'
                      }
                    />
                  </GridItem>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Email
                    </FormLabel>
                    <Input
                      isDisabled={true}
                      value={
                        Array.isArray(propertyData?.residents) && propertyData?.residents[0]
                          ? propertyData?.residents[0]?.emailAddress
                          : '---'
                      }
                    />
                  </GridItem>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Phone Number
                    </FormLabel>
                    <Input
                      value={
                        Array.isArray(propertyData?.residents) && propertyData?.residents[0]
                          ? propertyData?.residents[0]?.phoneNumber
                          : '---'
                      }
                      isDisabled={true}
                    />
                  </GridItem>
                </Grid>
              </Box>
            </Box>
            <Box pt={'4'}>
              <Flex alignItems={'center'}>
                <Text fontWeight={'500'} fontSize={'md'} display={'inline-block'} flexGrow={1} w={'25%'}>
                  Client&nbsp;Information
                </Text>
                <Divider borderWidth={'1px'} borderColor={'#CBD5E0'} />
              </Flex>
              <Box pt={'3'}>
                <Grid templateColumns="repeat(3, 280px)" gap="25px" pb={2}>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Name
                    </FormLabel>
                    <Input
                      isDisabled={true}
                      value={propertyData?.client?.companyName ? propertyData?.client?.companyName : '---'}
                    />
                  </GridItem>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Email
                    </FormLabel>
                    <Input
                      isDisabled={true}
                      value={
                        Array.isArray(propertyData?.client?.contacts) && propertyData?.client?.contacts[0]
                          ? propertyData?.client.contacts[0]?.emailAddress
                          : '---'
                      }
                    />
                  </GridItem>
                  <GridItem>
                    <FormLabel fontSize="14px" fontWeight="500" color="gray.600">
                      Phone Number
                    </FormLabel>
                    <Input
                      value={
                        Array.isArray(propertyData?.client?.contacts) && propertyData?.client?.contacts[0]
                          ? propertyData?.client.contacts[0]?.phoneNumber
                          : '---'
                      }
                      isDisabled={true}
                    />
                  </GridItem>
                </Grid>
              </Box>
            </Box>
          </VStack>
        </Box>
      )}
    </Box>
  )
}

export default PropertyAndClientTab
